import React, { useState } from 'react'
import s from './DocAdTwo.module.css'
import Image from "next/legacy/image"


export interface AccuracySecurityProps {
  title?: string
  image?: any
  className?: string
  text?: string
}

const DocAdTwo: React.FC<AccuracySecurityProps> = ((props) => {
  let {
    text,
    className,
    title,
    image
  } = props

  return (
    <div className={`${s.root}`}>
      <div>
        <div className={`grid grid-cols-1 lg:grid-cols-2`}>
          <div className='md:mr-0 md:ml-space10 xl:mr-space10'>
            <div className={'h-full w-full relative'}>
              <div className={s.innerWrapper}>
                <div>
                  <h3 className={`${s.title}`}>{title}</h3>
                </div>
                <div>
                  <p className={'lg:px-10'}>{text}</p>
                </div>
              </div>
            </div>
          </div>
          <div className={s.titleCover}>
            {image && <div
              className={s.image + ' block w-e336 h-e420 rounded-cornerL overflow-hidden block overflow-hidden absolute flex align-middle text-center'}>
              <div className={'relative w-full h-full'}>
                <Image alt='Doc image' priority={false} loading="lazy" src={image} layout='fill' objectFit='contain' />
              </div>
            </div>}
          </div>
        </div>
      </div>
    </div>
  )
})

export default DocAdTwo
